export const WORK_SCHEDULE_TYPE_OPTIONS = [
  { value: 'REGULAR', label: 'Regular' },
  { value: 'FLEXIBLE', label: 'Flexível' },
  { value: 'PART_TIME', label: 'Meio Período' },
  { value: 'OVERTIME', label: 'Horas Extras' },
  { value: 'FIXED', label: 'Fixa' }
];

export const WEEKLY_DAYS_OPTIONS = [
  { value: 'MONDAY', label: 'Segunda-feira' },
  { value: 'TUESDAY', label: 'Terça-feira' },
  { value: 'WEDNESDAY', label: 'Quarta-feira' },
  { value: 'THURSDAY', label: 'Quinta-feira' },
  { value: 'FRIDAY', label: 'Sexta-feira' },
  { value: 'SATURDAY', label: 'Sábado' },
  { value: 'SUNDAY', label: 'Domingo' }
];

export const WORK_SCHEDULE_TABLE_COLUMNS = [
  { id: 'name', label: 'Nome da Jornada', minWidth: 170 },
  { id: 'type', label: 'Tipo', minWidth: 120 },
  { id: 'startTime', label: 'Início', minWidth: 100 },
  { id: 'endTime', label: 'Fim', minWidth: 100 },
  { id: 'weeklyDays', label: 'Dias da Semana', minWidth: 150 },
  { id: 'actions', label: 'Ações', minWidth: 120 }
];

export const WORK_SCHEDULE_TYPE_COLORS = {
  REGULAR: '#4CAF50',
  FLEXIBLE: '#2196F3',
  PART_TIME: '#FF9800',
  OVERTIME: '#F44336'
}; 